import React, { createContext } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
// import { CartProvider } from './components/store/CartContext';
// import { FavoriteProvider } from './components/store/FavoriteContext';
import UserStore from './UserStore';
import { bindUserStore } from './http';

// Figma визуальные оверрайды грузим ПОСЛЕ App (т.е. после всех
// component-CSS) — нужна верхняя позиция в каскаде для :root.
import './styles/figma-overrides.css';

export const Context = createContext(null);
const userStore = new UserStore();
bindUserStore(userStore);

// Получаем корневой элемент и создаем root
const root = createRoot(document.getElementById('root'));

// Рендерим приложение
root.render(
  <Context.Provider value={{ user: userStore }}>
    <React.StrictMode>
      <App />
      {/* <CartProvider>
        <FavoriteProvider>
          
        </FavoriteProvider>
      </CartProvider> */}
    </React.StrictMode>
  </Context.Provider>
);